/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import {
  Directive,
  EmbeddedViewRef,
  Injector,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  effect,
  inject,
  input,
} from '@angular/core';
import { targetSelector } from '@app/core/ngrx';
import { GGCCTarget } from '@app/core/types';
import { Store } from '@ngrx/store';

@Directive({
  selector: '[showForTarget]',
})
export class ShowForTargetDirective<Context> implements OnInit {
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private store = inject(Store);
  private injector = inject(Injector);

  public showForTarget = input.required<GGCCTarget>();

  private target = this.store.selectSignal(targetSelector);
  private viewRef?: EmbeddedViewRef<Context>;

  ngOnInit(): void {
    effect(
      () => {
        const showForTarget = this.showForTarget();
        const target = this.target();
        const shouldRender = target !== undefined && !this.viewRef && target === showForTarget;
        const shouldHide = target === undefined || (!!this.viewRef && target !== showForTarget);
        if (shouldRender) {
          this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        }
        if (shouldHide) {
          this.viewContainer.clear();
          this.viewRef = undefined;
        }
      },
      {
        injector: this.injector,
      },
    );
  }
}
